import { render, staticRenderFns } from "./PriceChange.vue?vue&type=template&id=6f1f1757&scoped=true&"
import script from "./PriceChange.vue?vue&type=script&lang=js&"
export * from "./PriceChange.vue?vue&type=script&lang=js&"
import style0 from "./PriceChange.vue?vue&type=style&index=0&id=6f1f1757&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.8_eeqz4xtr3chsfpwu4zsrvzqhvy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1f1757",
  null
  
)

export default component.exports